import React from "react";
import { Link } from "react-router-dom"

function About() {
  return (
    <div style={{ marginTop: "50px", textAlign: "center" }}>
      <h2 style={{ marginBottom: "50px" }} >This is notes maker app made by Dheeraj Yadav</h2>
      <Link to="/">Go Back</Link>
    </div>
  );
}
export default About;
